<script lang="ts">
  export let klass = "";
  export let theme = "";
</script>

<div class="bg-white rounded-xl py-6 px-7 w-full {theme} {klass}">
  <slot />
</div>

<style lang="postcss">
  .blue {
    @apply bg-blue-50;
  }

  .limit-screen {
    height: calc(
      100vh - var(--custom-navbar-height) - var(--custom-footer-height) -
        var(--custom-main-padding) * 2
    );
    @apply overflow-y-scroll;
  }
</style>
